import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/form.module';


export default function MentorsBasicInfoComponent({ handleInnerFormChange, id, selectedMentors }: any) {
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              isDisabled={id !== '0'}
              label="Phone"
              name="Phone"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Login.Phone',
                  selectedMentors?.Login
                )
              }}
              type="number"
              value={selectedMentors?.Login?.Phone}
            />
            <InputContainer
              isDisabled={id !== '0'}
              label="Email"
              name="Email"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Login.Email',
                  selectedMentors?.Login
                )
              }}
              type="text"
              value={selectedMentors?.Login?.Email}
            />
            {id === '0' && (
              <InputContainer
                icon
                label="Password"
                name="Password"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'Login.Password',
                    selectedMentors?.Login
                  )
                }}
                type="password"
                value={selectedMentors?.Login?.Password}
              />)}
            {id === '0' && (
              <InputContainer
                icon
                label="Confirm Password"
                name="ConfirmPassword"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'Login.ConfirmPassword',
                    selectedMentors?.Login
                  )
                }}
                type="password"
                value={selectedMentors?.Login?.ConfirmPassword}
              />
            )}


          </div>
        }
        expandedPanel="LoginInfo"
        headerTitle="Basic Info"
      />

    </>
  )
}